import axios from 'axios';
import { cachetime } from '../config';
import poi from '../modules/poi';

export default function(){
  return {
    namespaced: true,
    state: {
      popular: {},
    },
    mutations: {
      UPDATE_POPULAR(state, { data, locale }) {
        state.popular = {
          ...state.popular,
          [locale]: {
            data: data,
            __updatedAt: Date.now()
          }
        }
      },
    },
    actions: {
      FETCH_POPULAR({ state, commit, dispatch }, { locale }) {
        if (state.popular[locale] && Date.now() - state.popular[locale].__updatedAt < cachetime) return;
        return axios.get(encodeURI(`/api/popularattraction`))
          .then((res) => {
            const data = res.data || [];

            data.forEach(({attractions}, i) => {
              if (!attractions || attractions.length == 0) return;

              let topIdx = Math.floor(Math.random() * attractions.length);

              let tmp = { ...attractions[0] };
              attractions[0] = { ...attractions[topIdx] };
              attractions[topIdx] = { ...tmp };
            })

            commit('UPDATE_POPULAR', { data, locale });
          }).catch(err => console.log(err));
      },
    },
    getters: { 
      getPopular: (state) => (locale) => {
        return state.popular[locale] ? state.popular[locale].data || [] : [];
      }
    },
    modules: {
      poi: poi(),
    }
  }
}